/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import { format } from "../../util/DateUtil";
import * as FUNC from "../../functions/functions";

const AppInformation = (props) => {
  const [content, setContent] = useState({});

  useEffect(() => {
    if (
      props.hasOwnProperty("config") &&
      props.config.hasOwnProperty("fields") &&
      props.config.hasOwnProperty("actions")
    ) {
      dataWidget();
    }
  }, []);

  const dataWidget = async () => {
    let x = await FUNC.filter(props.data, props.config.fields.in);
    x = await FUNC.exclude(x, props.config.fields.ex);
    setContent(JSON.parse(JSON.stringify(x)));
  };

  return (
    <div className="size-6 dataBlock">
      {props.data && (
        <div className="card">
          <div className="head flex align-center justify-between form-row">
            <i className="ibon-cellphone fx-elm-i inb2 col-ico"></i>
            <h3 className="col-9 fix-elm-title-widget">
              Información de la app
            </h3>
            <div className="col-2"></div>
          </div>
          <br />
          <div className="dataBlockItem">
            <label className="neutral">Instalación</label>
            <p>{format(props.data.cdate)}</p>
          </div>
          <div className="dataBlockItem">
            <label className="neutral">Estatus app</label>
            <p>{props.data.status}</p>
          </div>
          {
            content['platform'] &&
            <div className="dataBlockItem">
              <label className="neutral">Plataforma</label>
              <p>{props.data.platform}</p>
            </div>
          }
          <div className="dataBlockItem">
            <label className="neutral">Dispositivo</label>
            <p>{props.data.device_name}</p>
          </div>
          <div className="dataBlockItem">
            <label className="neutral">Versión app</label>
            <p>{props.data.app_version}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppInformation;
